import { BaseBus } from "./BaseBus";
import { v_DispatchNoteBus } from "./v_DispatchNoteBus";
import { SearchTarget } from "@app/cp/shared/enums/SearchTarget";

export class DispatchItemBus extends BaseBus
{
    constructor(dataObj: DispatchItemBus = null) {
        super(dataObj);
    }
    dispatchId: any;
    dispatchNumber: string;
    wonumber: string;
    receivedDateTime: Date;
    dispatchStatusName: string;
    dispatchStatusCategory: string;
    locationName: string;
    customerId: string;
    color: number;
    priorityColor: string;
    dispatchBoardColor: number;
    boardColorHex: string;
    priorityName: string;
    dispatchReason: string;
    locationId: any;
    isOpen: boolean;
    dispatchNotes: v_DispatchNoteBus[];
    receivedDateTimeStr: string;
    personToAssignId: any; 
    from: any;
}
